import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import pagew from './modules/page'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    pagew
  }
})
